"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NotificationHolder = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _logger = require("../logger");
var _utils = require("../utils");
var _Notification = require("./Notification");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    };
});
const NotificationHolder = (param)=>{
    let { notificationMessages } = param;
    (0, _logger.logDebug)("NotificationHolder: ", notificationMessages);
    const dispatchAcceptNotification = (0, _react.useCallback)((id)=>{
        const reasonId = Number(id);
        if (reasonId !== 0) {
            (0, _logger.logDebug)("Message ".concat(id, " triggered @ori-events/accept-notification."));
            (0, _utils.dispatchAcceptNotificationEvent)(reasonId);
        }
    }, []);
    // if there are no records we should not render anything but that should be already caught on previous step
    if (typeof notificationMessages === 'undefined' || notificationMessages.length === 0) {
        (0, _logger.logDebug)('No more messages to display. Exiting ...');
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        children: notificationMessages.map((message)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_Notification.Notification, {
                closeCallback: dispatchAcceptNotification,
                notificationMessage: message
            }, message.id))
    });
};
exports.NotificationHolder = NotificationHolder;
